import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Grow, Paper } from "@mui/material";
import SwiperCore, { Navigation, Pagination, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Phone from "./Phone";
import { CampaignFromInsight, Campaigns } from "../../../../../types/campaigns";
import { styled } from "@mui/styles";

const WIDTH = '100%';
const HEIGHT = '100%';

const Div = styled('div')({});
const Video = styled('video')({});
const Iframe = styled('iframe')({});
const Img = styled('img')({
  width: WIDTH,
  height: HEIGHT,
});

SwiperCore.use([Navigation, Pagination, A11y]);
interface PreviewProps {
  campaign?: CampaignFromInsight | Campaigns;
  type: any;
  adsImgIframe?: string;
}

export default function Preview({ campaign, type, adsImgIframe }: PreviewProps) {
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (type === "EMAIL") {
      (async () => {
        const { data } = await axios.get(campaign!.mensagem);
        setEmail(data);
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, campaign?.mensagem]);

  if (type && type.includes("FACEBOOK")) {
    return (
      <Grow in>
        <Paper variant="outlined">
          <Box>
             {campaign?.whatsapp_url.endsWith("mp4") ? (
              <Video style={{ width: WIDTH, height: HEIGHT }} controls autoPlay>
                <source src={campaign?.whatsapp_url} type="video/mp4" />
              </Video>
            ) : (
              <Img
                src={campaign?.whatsapp_url}
                alt="imagem"
              />
            )}
          </Box>
        </Paper>
      </Grow>
    );
  } else if (type && type.includes("INSTAGRAM")) {
    return (
      <Grow in style={{ width: '425px', height: '425px'}}>
        <Paper variant="outlined">
          <Box width={'100%'} height={'100%'}>
            {Array.isArray(campaign?.whatsapp_url) ? (
              <Swiper
                slidesPerView={1}
                spaceBetween={0}
                loop={true}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="dsCampaignPreviewCarrossel"
              >
                 {campaign?.whatsapp_url.map((media: any, index: any) => (
                  <SwiperSlide key={index.toString()}>
                    {media.url.endsWith('mp4') ? (
                      <Video width={'100%'} controls autoPlay>
                        <source src={media.url} type="video/mp4" />
                      </Video>
                    ) : (
                       <Img
                        style={{ width: "100%" }}
                        src={media.url}
                        alt="imagem"
                      />
                    )}
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : campaign?.whatsapp_url &&
              campaign?.whatsapp_url.endsWith("mp4") ? (
              <Video style={{ width: "100%" }} controls autoPlay>
                <source src={campaign?.whatsapp_url} type="video/mp4" />
              </Video>
            ) : (
              <Img
                style={{ width: "100%" }}
                src={campaign?.whatsapp_url}
                alt="imagem"
              />
            )}
          </Box>
        </Paper>
      </Grow>
    );
  }else if (type === "ADS") {
    return (
      <>  
        {campaign?.whatsapp_url ? 
        (<Img 
          src={campaign?.whatsapp_url}
          alt="img"
        /> ) : (
          campaign?.media_ads && campaign?.media_ads.length > 1 ? (
            <Swiper
              slidesPerView={1}
              spaceBetween={0}
              loop={true}
              pagination={{
                clickable: true,
              }}
              navigation={true}
              modules={[Pagination, Navigation]}
              className="dsCampaignPreviewCarrossel"
            >
               {campaign?.media_ads.map((media: any, index: any) => (
                <SwiperSlide key={index.toString()}>
                  {media.url.endsWith('mp4') ? (
                    <Video width={'100%'} controls autoPlay>
                      <source src={media.url} type="video/mp4" />
                    </Video>
                  ) : (
                     <Img
                      style={{ width: "100%" }}
                      src={media.url}
                      alt="imagem"
                    />
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          ) : 
          campaign?.media_ads.length ?
            campaign?.media_ads[0].url.endsWith("mp4") ? (
              <Video style={{ width: "100%" }} controls autoPlay>
                <source src={campaign?.media_ads[0].url} type="video/mp4" />
              </Video>
              ) : (
                <Img
                  style={{ width: "100%" }}
                  src={campaign?.media_ads[0]?.url}
                  alt="imagem"
                />
              )
          : <Iframe
              title="ADS Iframe"
              src={`https://www.facebook.com/plugins/post.php?href=https://www.facebook.com/${
                adsImgIframe?.split("_")[0]
              }/posts/${
                adsImgIframe?.split("_")[1]
              }/&show_text=true&width=480`}
              width="100%"
              height="600"
              style={{
                border: "none",
                overflow: "hidden",
              }}
              scrolling="no"
              frameBorder="0"
              allowFullScreen={true}
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            />)}
      </>
    );
  }else if (type === "EMAIL") {
    return (
      <Grow in>
        <Div
          style={{ width: WIDTH, overflow: "auto", height: "95vh" }}
          dangerouslySetInnerHTML={{
            __html: email,
          }}
        />
      </Grow>
    );
  }else if (type === "WHATSAPP") {
    return <Phone isWhatsapp data={campaign} />;
  } else if (type === "WHATSAPP_STATUS") {
    return <Phone isStatusWhatsapp data={campaign} />;
  } else if (type === "WHATSAPP_GROUP") {
    return <Phone isStatusWhatsapp data={campaign} />;
  } else if (type === "SMS") {
    return <Phone data={campaign} />;
  } else if (type === "SMS_V2") {
    return <Phone data={campaign} />;
  }
  return <Div id="empty" />;
}
